import { type KeyValue, KeyValueTable } from "@/components/fragments/table";
import { formatAsiaTokyoDateToString } from "@/modules/utils/date";
import type { FC } from "react";
import { getToyCouponStatus } from "@/pages/settings/account/toy-coupon/module";
import { type ToyCoupon } from "@/pages/settings/account/toy-coupon/type";
import { unavailableToyCouponTableTestId } from "./const";

type UnavailableToyCouponTableProps = ToyCoupon;

export const UnavailableToyCouponTable: FC<UnavailableToyCouponTableProps> = (
  props: UnavailableToyCouponTableProps,
) => {
  const { couponNumber, price, issuedAt, expiresAt, usedAt } = props;

  const status = getToyCouponStatus(props);

  const toyCouponTableData: KeyValue[] = [
    {
      key: "状態",
      value:
        status === "used"
          ? `使用済み：${formatAsiaTokyoDateToString(usedAt, "yyyy/MM/dd") ?? ""}`
          : `失効：${formatAsiaTokyoDateToString(expiresAt, "yyyy/MM/dd") ?? ""}`,
    },
    {
      key: "クーポン番号",
      value: couponNumber,
    },
    {
      key: "金額",
      value: `${price.toString()}円OFF`,
    },
    {
      key: "発行日",
      value: formatAsiaTokyoDateToString(issuedAt, "yyyy/MM/dd") ?? "なし",
    },
    {
      key: "有効期限",
      value: formatAsiaTokyoDateToString(expiresAt, "yyyy/MM/dd") ?? "なし",
    },
  ];
  return <KeyValueTable data={toyCouponTableData} data-testid={unavailableToyCouponTableTestId} />;
};
